import { useQuery } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';

const { CONTROLLERS: { PLAID }, BASE: USER_BASE } = USER;

const { ROUTES: { LINKED_ACCOUNTS: { VERSION, BASE: GENERATE_BASE } } } = PLAID;

export const useGetLinkedAccountsQuery = (customerId: string) => useQuery(
  'getLinkedAccounts',
  async () => {
    if (!customerId) {
      return null;
    }
    const { data } = await httpService.get((`${BASE_URL}/${USER_BASE.replace('{version}', VERSION)}/${customerId}/${GENERATE_BASE}`));
    return data;
  },
  {
    cacheTime: 0,
    enabled: false,
  },
);
